import pic11 from './assets/images/11.jpg';
import pic12 from './assets/images/12.jpg';
import pic13 from './assets/images/13.jpg';
import pic14 from './assets/images/14.jpg';

import svg11 from './assets/svg/11.svg';
import svg12 from './assets/svg/12.svg';
import svg13 from './assets/svg/13.svg';
import svg15 from './assets/svg/15.svg';
import svg16 from './assets/svg/16.svg';

const One = () => (
	<section>
		<div className="section-num">1</div>
		<p><img src={pic11} alt="" /></p>
		<div className="wrapper">
			<h2>Stromy město zklidňují</h2>
			<p className="like-h3">Zdejší Prochaskův lesopark začal tvořit v roce 1911 mikulovský Okrašlovací spolek. Své jméno dostal lesopark na&nbsp;počest Karla Prochasky, který finančně podpořil jeho založení.</p>
			<p className="txt-right" style={{marginBottom: "1em"}}>
				<span className="relative inline-block" style={{maxWidth: "85%"}}>Záměrem spolku bylo vytvořit klidové místo mezi stromy. Alej z jírovců maďalů (lidově kaštanů), ve které právě stojíš, umí výrazně rozptýlit hluk a pomáhá zachycovat prach z cesty.
					<img src={svg11} className="pointer" style={{top: "70%", right: "75%", maxWidth: "100px"}} alt="" />
				</span>
			</p>
		</div>
		<p style={{marginTop: "-1em", marginBottom: ".5em"}}>
			<img src={pic12} alt="" />
		</p>
		<div className="wrapper">
			<p className="txt-right">
				<span className="relative inline-block" style={{maxWidth: "16em"}}>Ve městech je velkým zdrojem hluku doprava. Stromy umí vytvářet zvukovou bariéru a vytváří tak pro obyvatele příjemnější a klidnější místa.
					<img src={svg12} className="pointer" style={{bottom: "100%", right: 0, maxWidth: "36%"}} alt="" />
				</span>
			</p>
			<h2>Přírodní klimatizace</h2>
			<p className="txt-center like-h3" style={{marginLeft: ".5em", marginRight: ".5em"}}>V létě je město oproti okolní krajině výrazně teplejší. Je totiž plné povrchů, které teplo pohlcují a&nbsp;vytváří něco jako horkou pec.</p>
			<p className="relative" style={{marginBottom: "1em", marginRight: "1em"}}>Ulice, na které jsou vysazené stromy, jsou výrazně příjemnější. Strom umí svým stínem prostor pod sebou zchladit o více než 15 °C.
				<img src={svg13} className="pointer" style={{top: "100%", right: "30%", maxWidth: "100px"}} alt="" />
			</p>
		</div>
		<p className="mb-0"><img src={pic13} alt="" /></p>
		<div className="wrapper">
			<p>
				<b className="tip">Tip pro tebe:</b> Vyzkoušej, jaký je rozdíl mezi stínem, který poskytuje strom a kterýje pod běžným slunečníkem.
			</p>
			<h2>Stromy přináší vláhu</h2>
			<p className="like-h3" style={{marginLeft: ".25em", marginRight: ".25em"}}>Stín stromu je příjemný i proto, že&nbsp;pod ním proudí vláha. Při působení slunečního svitu odpařuje strom ze&nbsp;země vodní páru a tím se zem pod&nbsp;ním ochlazuje.</p>
			<p className="txt-right" style={{marginBottom: ".5em"}}>
				<span className="relative inline-block" style={{maxWidth: "11em"}}>Strom vrací do atmosféry vláhu a pomáhá tak vytvářet srážky.
					<img src={svg15} className="pointer" style={{top: "80%", right: "92%", maxWidth: "12%"}} alt="" />
				</span>
			</p>
		</div>
		<p><img src={pic14} alt="" /></p>
		<div className="wrapper">
			<p className="relative" style={{marginTop: "-.75em"}}>Běžný strom v parku dokáže odpařit až 200 litrů vody za den. Oproti tomu dospělý člověk za den vypotí a vydechne jen necelý 1 litr vody.
				<img src={svg16} className="pointer" style={{bottom: "100%", left: "-2%", maxWidth: "280px"}} alt=""/>
			</p>
		</div>
	</section>
);

export default One;
